import { MoreCompetencesList } from "modules/PsyCatalog/common/MoreCompetencesList"

interface Props {
    competences: string[]
}

export function CompetencesSection({ competences }: Props) {
    if (competences.length === 0) return null
    function competenceRender(str: string) {
        return (
            <li key={str} className="details__list-item">
                {str}
            </li>
        )
    }

    return (
        <ul className="details__list">
            {competenceRender(competences[0])}
            {competences.length > 2 ? (
                <MoreCompetencesList competences={competences.slice(1, 4).map(competenceRender)} />
            ) : (
                competences.length === 2 && competenceRender(competences[1])
            )}
        </ul>
    )
}
